import * as i0 from '@angular/core';
import { NgModule, Injectable } from '@angular/core';
import * as i1 from '@upr-web-primer/gds-poi-filter';
import { isEmpty, filter, intersection, includes } from 'lodash-es';
class GdsRelatedTileModule {
  static {
    this.ɵfac = function GdsRelatedTileModule_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || GdsRelatedTileModule)();
    };
  }
  static {
    this.ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
      type: GdsRelatedTileModule
    });
  }
  static {
    this.ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({});
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(GdsRelatedTileModule, [{
    type: NgModule,
    args: [{}]
  }], null, null);
})();
class GdsRelatedTilesService {
  constructor(poiFilter) {
    this.poiFilter = poiFilter;
  }
  getRelatedTiles(pageTile, tiles, interest) {
    if (isEmpty(tiles) || !pageTile) {
      return [];
    }
    return filter(tiles, tile => this.hasRelatedProperties(pageTile, tile, 'AttractionExperiences') && this.hasRelatedProperties(pageTile, tile, 'AttractionLocations') && (interest ? this.hasAttribute(tile, 'AttractionInterests', interest) : true));
  }
  hasRelatedProperties(pageTile, tile, property) {
    const criteriaKey = this.poiFilter.getTileKeys(pageTile, property);
    const tileKey = this.poiFilter.getTileKeys(tile, property);
    if (!criteriaKey && !tileKey) {
      return true;
    }
    return intersection(criteriaKey, tileKey).length > 0;
  }
  hasAttribute(tile, property, condition) {
    return includes(this.poiFilter.getTileKeys(tile, property), condition);
  }
  static {
    this.ɵfac = function GdsRelatedTilesService_Factory(__ngFactoryType__) {
      return new (__ngFactoryType__ || GdsRelatedTilesService)(i0.ɵɵinject(i1.GdsPoiFilterService));
    };
  }
  static {
    this.ɵprov = /* @__PURE__ */i0.ɵɵdefineInjectable({
      token: GdsRelatedTilesService,
      factory: GdsRelatedTilesService.ɵfac,
      providedIn: 'root'
    });
  }
}
(() => {
  (typeof ngDevMode === "undefined" || ngDevMode) && i0.ɵsetClassMetadata(GdsRelatedTilesService, [{
    type: Injectable,
    args: [{
      providedIn: 'root'
    }]
  }], () => [{
    type: i1.GdsPoiFilterService
  }], null);
})();

/*
 * Public API Surface of gds-related-tile
 */

/**
 * Generated bundle index. Do not edit.
 */

export { GdsRelatedTileModule, GdsRelatedTilesService };
